"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_json_view_1 = __importDefault(require("@microlink/react-json-view"));
var material_1 = require("@mui/material");
var fast_xml_parser_1 = require("fast-xml-parser");
var omit_1 = __importDefault(require("lodash/omit"));
var pickBy_1 = __importDefault(require("lodash/pickBy"));
var react_1 = __importDefault(require("react"));
var react_base16_styling_1 = require("react-base16-styling");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var validators_1 = require("utils/form/validators");
var utils_1 = require("utils/selectors/utils");
var DebugXeroForm_1 = __importDefault(require("./DebugXeroForm"));
var utils_2 = require("./utils");
var selectXeroConnections = (0, utils_1.makeSelectOrdered)('xeroConnections');
var xmlParser = new fast_xml_parser_1.XMLParser();
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var DebugXero = function () {
    var _a;
    var _b = __read(react_1.default.useState(false), 2), drawerOpen = _b[0], toggleDrawer = _b[1];
    var _c = __read(react_1.default.useState(false), 2), showXmlParsed = _c[0], setShowXmlParsed = _c[1];
    var _d = __read(react_1.default.useState(''), 2), connId = _d[0], setConnId = _d[1];
    var _e = __read(react_1.default.useState(null), 2), resp = _e[0], setResp = _e[1];
    // const [jsonUrl, setJsonUrl] = React.useState<string | null>(null);
    window.xeroResp = resp;
    var _f = __read((0, backend_1.useCall)('transactions-xero-testXero'), 1), callTestXero = _f[0];
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{
            collection: 'integration_connections',
            storeAs: 'xeroConnections',
            where: [['provider', '==', 'Xero'], ['companyId', '!=', '']],
        }]; });
    var xeroConnections = (0, react_redux_1.useSelector)(selectXeroConnections);
    var testXero = function (_a) {
        var endpoint = _a.endpoint, method = _a.method, bodyValue = _a.body, params = __rest(_a, ["endpoint", "method", "body"]);
        var filteredParams = ['POST', 'PUT'].includes(method) ? (0, omit_1.default)(params, ['where', 'Statuses', 'page', 'fetchAllPages']) : params;
        var body = ['POST', 'PUT'].includes(method) ? bodyValue && JSON.parse(bodyValue.trim()) : undefined;
        return callTestXero({
            connId: connId,
            endpoint: endpoint,
            params: (0, pickBy_1.default)(filteredParams),
            body: body,
            method: method,
        })()
            .then(function (r) {
            setResp(r === null || r === void 0 ? void 0 : r.data);
            toggleDrawer(true);
        });
    };
    var connections = (xeroConnections === null || xeroConnections === void 0 ? void 0 : xeroConnections.filter(function (c) { return !c.deletedOn && !c.isDisconnected && c.hasActiveRefreshToken; })) || [];
    var makeCustomerOptions = function (conn) { return ({
        value: conn.id,
        label: "".concat(conn.tenantName, " (").concat(conn.accUserEmail, ") (").concat(conn.xeroAppId).concat(conn.specialConnectionType ? " - ".concat(conn.specialConnectionType) : '', ")"),
    }); };
    var options = connections.map(makeCustomerOptions);
    var handleChange = function (valObj) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (valObj && 'value' in valObj && (valObj === null || valObj === void 0 ? void 0 : valObj.value)) {
                setConnId(valObj.value);
            }
            return [2 /*return*/, valObj];
        });
    }); };
    var selectedValue = {
        value: connId,
        label: (_a = options.find(function (c) { return c.value === connId; })) === null || _a === void 0 ? void 0 : _a.label,
    };
    var selectedConnection = connections === null || connections === void 0 ? void 0 : connections.find(function (iC) { return iC.id === connId; });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: 750, pt: 4, pb: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: 350, pb: 2 }, { children: (0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { options: options, label: "Customer", placeholder: "Select a customer", onChange: handleChange, noOptionsText: "Customer not found", value: selectedValue !== null && selectedValue !== void 0 ? selectedValue : null, btnProps: { className: 'highlightInput' } }) })), selectedConnection && ((0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: testXero, initialValues: { method: 'GET' }, validate: function (fV) { return (0, validators_1.requiredFields)(['endpoint'])(__assign({}, fV)); } }, { children: function (formProps) { return (0, jsx_runtime_1.jsx)(DebugXeroForm_1.default, __assign({}, formProps, { toggleDrawer: toggleDrawer, intConn: selectedConnection, resp: resp })); } })))] })), (0, jsx_runtime_1.jsx)(material_1.Drawer, __assign({ anchor: "right", PaperProps: { sx: { backgroundColor: react_base16_styling_1.base16Themes.bright.base00, px: 4, py: 3 } }, open: drawerOpen, onClose: function () { return toggleDrawer(false); }, keepMounted: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: "60vw", minHeight: "100vh" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ position: "absolute", top: 5, right: 20 }, { children: (0, jsx_runtime_1.jsx)(IconButtons_1.CloseButton, { onClick: function () { return toggleDrawer(false); } }) })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", spacing: 2, width: 1, pb: 2 }, { children: [(resp === null || resp === void 0 ? void 0 : resp.RepeatingInvoices) && ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return (0, utils_2.getReptInvsLineItems)(resp.RepeatingInvoices, xeroConnections === null || xeroConnections === void 0 ? void 0 : xeroConnections.find(function (xC) { return xC.id === connId; })); } }, { children: "Get Repeating InvoicesLine Items" }))), (resp === null || resp === void 0 ? void 0 : resp.Invoices) && ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return (0, utils_2.getInvsLineItems)(resp.Invoices, xeroConnections === null || xeroConnections === void 0 ? void 0 : xeroConnections.find(function (xC) { return xC.id === connId; })); } }, { children: "Get Invoices Line Items" }))), (resp === null || resp === void 0 ? void 0 : resp.xml) && (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return setShowXmlParsed(!showXmlParsed); } }, { children: "Parse Xml" }))] })), drawerOpen && resp && ((0, jsx_runtime_1.jsx)(react_json_view_1.default, { displayDataTypes: false, sortKeys: true, name: null, src: showXmlParsed && (resp === null || resp === void 0 ? void 0 : resp.xml) ? xmlParser.parse(resp === null || resp === void 0 ? void 0 : resp.xml) : resp, theme: "bright" })), drawerOpen && !resp && (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ color: "white" }, { children: "No reponse found" }))] })) }))] }));
};
exports.default = DebugXero;
